import { apiBaseUrl } from 'app/src/msw/companyagreement/api/apiBaseUrl'
import { productCollection } from 'app/src/msw/companyagreement/initialSeed/products'
import type { companyagreementApi } from 'app/src/services/welfareportal'
import { http, HttpResponse, type DefaultBodyType } from 'msw'

/**
 * Handles GET requests to the `/products/:productId` endpoint by retrieving a product from the `productCollection`
 * @param productId The ID of the product to retrieve
 * @returns The product with the specified ID, or an empty object if no such product exists
 */
export const getProduct = http.get<{ productId: string }, DefaultBodyType, companyagreementApi.Product | object>(
  apiBaseUrl + '/products/:productId',
  async ({ params }) => {
    try {
      const { productId } = params
      console.log('Received request for getProduct with params:', productId)
      const product = productCollection.findFirst((p) => p.where({ productId: productId }))

      if (!product) {
        return HttpResponse.json({}, { status: 404 })
      }

      return HttpResponse.json(product)
    } catch (error) {
      console.error('Error loading product:', error)
    }
  },
)
